<template>
    <div class="list-media" v-if="!!params.items && params.items.length>0">
        <div class="media-title">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link_info.link)" v-if="params.link_info.link">
                {{!!params.link_info.name?params.link_info.name:'更多'}}
            </div>
        </div>
        <div class="media-content">
            <div class="content-li" v-for="(item,index) in params.items" :key="index" @click="onClick(item.link)">
                <div class="time-table-title">
                    <div class="table-title-text">
                        <div class="title-text">
                            {{item.name}}
                        </div>
                        <div class="title-text-time">
                            开课时间：{{item.start_date}} {{item.start_time}}
                        </div>
                        <div class="title-text-appointment">
                            可预约：{{item.appoint_switch?item.appoint_max_num+'人':'不限'}}
                            <!--<span class="text-appointment-type">线上课</span>-->
                        </div>
                    </div>
                    <div class="table-title-img">
                        <img class="title-img" :src="item.items_cover" />
                    </div>
                </div>
                <div class="time-table-list" v-if="!!item.time_list && item.time_list.length>0">
                    <div class="table-list-title">包含课程</div>
                    <div class="table-list-center">
                        <div class="list-center-li" v-for="(items,indexs) in item.time_list" :key="indexs">
                            <div class="center-li-title">{{items.course_name}}</div>
                            <div class="center-li-txt">
                                {{items.start_date}} {{items.start_time}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "time_table",
        props:{
            params:Object
        },
        methods: {
            onClick(link) {
                // this.util.carouselUrl(link);
                this.$router.push(link);
            },
        },
    }
</script>

<style scoped>
    .list-media{
        width: 100%;
        /*margin-top: 10px;*/
        margin: 0.625rem 0;
    }
    .media-title{
        background-color: #fff;
    }
    .media-title .title-txt,.media-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .media-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #171717;
    }
    .media-title .title-more{
        float: right;
        color: #327CE9;
        font-size: 12px;
        margin-top: 2px;
    }
    .media-content{
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-wrap: wrap;
    }
    .media-content .content-li{
        margin: 10px 0;
        box-sizing: border-box;
        border: 1px solid #efefef;
        padding: 10px;
        width: 100%;
    }
    .time-table-title{
        position: relative;
        height:76px;
    }
    .table-title-text{
        padding-right: 105px;
    }
    .title-text{
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 32px;
    }
    .title-text-time{
        font-size: 12px;
        margin-top: 7px;
    }
    .title-text-appointment{
        font-size: 12px;
        position: relative;
        margin-top: 7px;
    }
    .text-appointment-type{
        position: absolute;
        right: 0;
        color: #f30;
    }
    .table-title-img{
        position: absolute;
        right: 0;
        top: 0;
    }
    .title-img{
        width: 100px;
        height: 76px;
    }
    .time-table-list{
        margin-top: 20px;
    }
    .table-list-title{
        font-size: 12px;
        font-weight: bold;
        border-bottom: 1px dashed #ddd;
        padding-bottom: 3px;
    }
    .table-list-center{

    }
    .list-center-li{
        position: relative;
        padding: 5px 0;
    }
    .center-li-title{
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 61%;
    }
    .center-li-txt{
        position: absolute;
        font-size: 12px;
        vertical-align: middle;
        top: 5px;
        right: 0;
    }
    .center-li-txt .iconchakan{
        font-size: 12px;
        color: #aaa;
        margin-right: 5px;
    }
</style>
